import { defineStore } from '../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import * as actions from './actions.js?vue3';
import mutations from './mutations';
import * as getters from './getters';

export const useBatchComments = defineStore('batchComments', {
  state() {
    return {
      isDraftsFetched: false,
      fetchDraftsPromise: null,
      drafts: [],
      isPublishing: false,
      publishReviewId: null,
      currentlyPublishingDrafts: [],
      shouldAnimateReviewButton: false,
      isMergeRequest: false,
      drawerOpened: false,
      // TODO: this gets populated from the sidebar_reviewers.vue, we should have a separate store for this
      isReviewer: false,
    };
  },
  actions: {
    ...mutations,
    ...actions,
  },
  getters,
});
